import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  paymentGrid: {
    maxWidth: 581,
    minWidth: 346,
  },
  checkoutGrid: {
    marginLeft: 64,
    height: 'fit-content',
    position: 'relative',
    top: 32,
    minWidth: 470,

    [theme.breakpoints.down('lg')]: {
      minWidth: '100%',
      marginLeft: 0,
    },
  },
  paymentButtonContainer: {
    '& button': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    '& button svg': {
      marginRight: 10,
    },
  },
  checkoutDisclaimer: {
    marginTop: theme.spacing(3),

    '& p': {
      color: '#616161',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '120%',
    },

    '& p a': {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '120%',
      color: '#7833FF',
    },
  },
}));
